export const translate = {
  Varzeshi: 'ورزشی',
  KoshtiVaVazneBardari: 'کشتی و وزنه برداری',
  SaiereHozeha: 'سایر حوزه‌ها',
  FootballIran: 'فوتبال ایران',
  FootballJahan: 'فوتبال جهان',
  Razmi: 'رزمی',
  ToopVaTour: 'توپ و تور',
  Siasi: 'سیاسی',
  EmamVaRahbari: 'امام و رهبری',
  AhzabVaTashakolha: 'احزاب و تشکل‌ها',
  AmniatiVaDefaee: 'امنیتی و دفاعی',
  Dolat: 'دولت',
  Majles: 'مجلس',
  TashakolhaieDaneshghai: 'تشکل‌های دانشگاهی',
  Eghtesadi: 'اقتصادی',
  EghtesadKalanVaBoodje: 'اقتصاد کلان و بودجه',
  TaavonVaEshteghal: 'تعاون و اشتغال',
  Boors: 'بورس',
  BimeVaBank: 'بیمه و بانک',
  RahVaMaskan: 'راه و مسکن',
  SanatTejaratBazargani: 'صنعت تجارت بازرگانی',
  KeshavarziVaOmooreDam: 'کشاورزی و امور دام',
  NaftVaEnergy: 'نفت و انرژی',
  EghtesadeBinolmelal: 'اقتصاد بین‌الملل',
  ElmiVaDaneshghai: 'علمی و دانشگاهی',
  Amouzesh: 'آموزش',
  ElamVaFanavariIran: 'علم و فناوری ایران',
  ElamVaFanavariJahan: 'علم و فناوری جهان',
  ElamVaFanavari: 'علم و فناوری ',
  Farhang: 'فرهنگ',
  KetabVaAdabiat: 'کتاب و ادبیات',
  Andishe: 'اندیشه',
  QuranVaFaaliathaieDini: 'قرآن و فعالیت‌های دینی',
  MasjedVaHeiat: 'مسجد و هیئت',
  HajVaZiaratVaVaghf: 'حج و زیارت و وقف',
  Ejtemaee: 'اجتماعی',
  Salamat: 'سلامت',
  AmouzeshVaParvaresh: 'آموزش و پرورش',
  HoghoughiVaGhazaee: 'حقوقی و قضایی',
  EntezamiVaHavades: 'انتظامی و حوادث',
  MohitZistVaGardeshgari: 'محیط زیست و گردشگری',
  Shahri: 'شهری',
  ZananVaJavanan: 'زنان و جوانان',
  HonarVaResane: 'هنر و رسانه',
  RadioVaTV: 'رادیو و تلویزیون',
  CinemaVaTheatre: 'سینما و تئاتر',
  MousighiVaHonarhaieTajasomi: 'موسیقی و هنرهای تجسمی',
  Beinolmelal: 'بین‌الملل',
  AmricaVaEurope: 'آمریکا و اروپا',
  SharghAsiaVaOghianousie: 'شرق آسیا و اقیانوسیه',
  GharbAsia: 'غرب آسیا',
  Africa: 'آفریقا',
  DiniVaMazhabi: 'دینی و مذهبی',
  FarhangHonarVaResane: 'فرهنگ هنر و رسانه',
  RefahVaAsibhaieEjtemaee: 'رفاه و آسیب‌های اجتماعی',
  Roozmare: 'روزمره',
  hashtag: 'هشتگ',
  word: 'کلمه',
  twitter: 'توییتر',
  virasty: 'ویراستی',
  news: 'خبر',
  instagram: 'اینستاگرام',
  instagramComment: 'کامنت اینستاگرام',
  telegram: 'تلگرام',
  newspaper: 'روزنامه',
  linkedin: 'لینکدین',
  nativePlatforms: 'بسترهای داخلی',
  eitaa: 'ایتا',
  bale: 'بله',
  rubika: 'روبیکا',
  total: 'مجموع',
  man: 'مرد',
  woman: 'زن',
  male: 'مرد',
  female: 'زن',
  org: 'بدون جنسیت (سازمان)',
  '<=18': 'کوچکتر از 18 سال',
  '19-29': '19 تا 29 سال',
  '30-39': ' 30 تا 39 سال',
  '>=40': 'بزرگتر از 40 سال',
};
